<div class="container-fluid text-center dial-ali">
  <div class="row justify-content-center">
    <div class="col-12 col-md-12">

      <h2 class="h2 my-4">Level 1 Edit</h2>
      <p class="mb-5">
        Fix grammer and spelling mistakes and use more appropriate vocabulary.
      </p>

      <h2 class="h2 my-4">Level 2 Edit</h2>
      <p class="mb-5">
       Fix grammer and spelling mistakes and make more concise.
      </p>

      <h2 class="h2 my-4">Level 3 Edit</h2>
      <p class="mb-5">
       Fix grammer and spelling mistakes and make more empathetic and personal.
      </p>

      <h2 class="h2 my-4">Level 4 Edit</h2>
      <p class="mb-5">
        Fix grammer and spelling mistakes and use more diverse vocabulary.
      </p>

     

    </div>
  </div>
</div>
